"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-38e8ff48"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "tile notification-card" };
const _hoisted_2 = { class: "tile-content" };
const _hoisted_3 = { class: "tile-title text-tiny align-center mb-1" };
const _hoisted_4 = { class: "label notification-text" };
const _hoisted_5 = { class: "notification-text mr-2" };
const _hoisted_6 = { class: "user-name-text text-big" };
const _hoisted_7 = { class: "text-gray col-ml-auto" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "divider my-1" }, null, -1 /* HOISTED */));
const _hoisted_9 = { class: "tile-subtitle mb-1" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "text-gray" };
const _hoisted_12 = { class: "notification-text" };
const vue_3 = require("vue");
const ShiftIcon_vue_1 = __importDefault(require("../../../assets/icons/ShiftIcon.vue"));
const MessageBoardIcon_vue_1 = __importDefault(require("../../../assets/icons/MessageBoardIcon.vue"));
const notificationType_1 = require("../type/notificationType");
const common_1 = require("../../../../common/common");
const timeZones_1 = __importDefault(require("../../../../common/timeZones"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'NotificationCard',
    props: {
        branchId: {
            type: Number,
        },
        userId: {
            type: Number,
        },
        notification: {
            type: Object,
            required: true,
        },
        type: {
            type: Number,
            required: true,
        },
        goToSummary: {
            type: Boolean,
            required: true,
        },
    },
    emits: ["mark-as-read"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Methods
        function goToNotificationPage() {
            if (!props.branchId || !props.userId) {
                return;
            }
            if (isBoardNotification.value) {
                window.location.href = `/dashboard/${props.userId}/board?c=${props.branchId}`;
            }
            else {
                const params = new URLSearchParams({
                    "list": props.goToSummary ? "day" : "week",
                    "c": props.branchId?.toString(),
                    "date": new Date(props.notification.slotData?.slotFrom || "").toISOString().split('T')[0] ?? "",
                });
                const path = props.goToSummary ? "summary" : "shift";
                window.location.href = `/dashboard/${props.userId}/${path}?${params.toString()}`;
            }
        }
        function markAsReadHandler(event) {
            event.stopPropagation();
            markAsRead();
        }
        function markAsRead() {
            emit("mark-as-read", props.notification.id, props.type);
        }
        // Computed Properties
        const isSlotNotification = (0, vue_3.computed)(() => {
            return props.type === notificationType_1.NotificationType.SlotNotification;
        });
        const isBoardNotification = (0, vue_3.computed)(() => {
            return props.type === notificationType_1.NotificationType.BoardNotification;
        });
        const notificationTitle = (0, vue_3.computed)(() => {
            if (isBoardNotification.value) {
                return props.notification.boardData?.parentID ? "掲示板コメント" : "掲示板メッセージ";
            }
            else {
                return "シフトコメント";
            }
        });
        const notificationDate = (0, vue_3.computed)(() => {
            const date = props.notification.date;
            const now = new Date();
            let dateFormat = { dateStyle: "medium", timeStyle: "short" };
            if (date.getDate() === now.getDate()
                && date.getMonth() === now.getMonth()
                && date.getFullYear() === now.getFullYear()) {
                dateFormat = { timeStyle: "short" };
            }
            return date.toLocaleString('ja-JP', dateFormat);
        });
        const slotStyle = (0, vue_3.computed)(() => {
            const slotColor = props.notification.slotData?.slotColor;
            return {
                'height': '1.1rem',
                'color': slotColor ? '#fff' : '',
                'background-color': slotColor ? `#${slotColor}` : '',
            };
        });
        const slotDate = (0, vue_3.computed)(() => {
            return (0, common_1.jpDateString)(new Date(props.notification.slotData?.slotFrom || ""), timeZones_1.default.ASIA_TOKYO);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                onClick: goToNotificationPage,
                class: "notify-link c-hand mt-2"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-sm btn-clear float-right",
                            onClick: markAsReadHandler
                        }),
                        (0, vue_2.createElementVNode)("p", _hoisted_3, [
                            (0, vue_2.createElementVNode)("span", _hoisted_4, [
                                (isSlotNotification.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShiftIcon_vue_1.default, { key: 0 }))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(MessageBoardIcon_vue_1.default, { key: 1 }))
                            ]),
                            (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(notificationTitle.value) + " (", 1 /* TEXT */),
                                (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(__props.notification.userName), 1 /* TEXT */),
                                (0, vue_2.createTextVNode)(") ")
                            ]),
                            (0, vue_2.createElementVNode)("small", _hoisted_7, (0, vue_2.toDisplayString)(notificationDate.value), 1 /* TEXT */)
                        ]),
                        _hoisted_8,
                        (0, vue_2.createElementVNode)("p", _hoisted_9, [
                            (isSlotNotification.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                    (0, vue_2.createElementVNode)("span", {
                                        class: "chip ml-0 mr-1",
                                        style: (0, vue_2.normalizeStyle)(slotStyle.value)
                                    }, (0, vue_2.toDisplayString)(__props.notification.slotData?.slotText), 5 /* TEXT, STYLE */),
                                    (0, vue_2.createElementVNode)("small", _hoisted_11, (0, vue_2.toDisplayString)(slotDate.value), 1 /* TEXT */)
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                            (0, vue_2.createElementVNode)("small", _hoisted_12, (0, vue_2.toDisplayString)(__props.notification.message), 1 /* TEXT */)
                        ])
                    ])
                ])
            ]));
        };
    }
});
